import {getPolishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Ohodnotit článek',
    message: 'Odevzdané hlasy',
    votes: votes => `${getPolishPlurals(["názor", "názory", "názory"], +votes)},`,
    score: 'hodnocení',
  },
  feedback: {
    label: 'Je tento článek užitečný?'
  }
};
